import React, {useState} from 'react';
import './QuantitySelectos.scss';
import Subtract from '../../../../assets/icons/Subtract';
import Plus from '../../../../assets/icons/Plus';

/**
 * @description
 * @param { object } props no redux
 * @return { * } component
 */

const QuantitySelector = (props)=>{
    const {handleChange, disable, value} = props;
    const [total, setTotal] = useState(value || 1);

    const handleValue = (value)=>{
        if (!disable) {
            if (value !== 0 && total < 7 ) {
                setTotal(value);
                handleChange(value);
            } else if (total === 7 && value<total) {
                setTotal(value);
                handleChange(value);
            }
        }
    };

    return (
        <div className={'quantity-selector-container'}>
            <div className={'quantity-selector-icon-container'} onClick={()=> handleValue(total - 1)}>
                <Subtract width={'10px'} height={'1px'}/>
            </div>
            {total}
            <div className={'quantity-selector-icon-container'} onClick={()=> handleValue(total +1)}>
                <Plus width={'10px'} height={'10px'}/>
            </div>
        </div>
    );
};


export default QuantitySelector;
